import { FEATURES } from "./features";

import type { NavItem } from "@/types/navigation";

/** Sidebar entries, aggregated from every registered feature. */
export const PRIMARY_NAV: readonly NavItem[] = FEATURES.flatMap((feature) => feature.navItems);
